// =====================================================================
// Deeplink-резолвер. Telegram Mini App открывается по ссылке вида
//   https://t.me/<bot>/<app>?startapp=<param>
// Параметр приходит в WebApp.initDataUnsafe.start_param. Маппим его в
// начальный маршрут ДО инициализации роутера (импортируется в main.tsx
// перед рендером BrowserRouter) — без useEffect.
//
// Форматы:
//   p-<productId>   → /product/<id>
//   c-<categoryId>  → / (с предустановленным фильтром категории)
//   promo|promo-... → /  (главная)
// =====================================================================

import { useFiltersStore } from "@/shared/store/filters";

function resolveDeeplink(): void {
  if (typeof window === "undefined") return;
  const w = window as { Telegram?: { WebApp?: { initDataUnsafe?: { start_param?: string } } } };
  const param = w.Telegram?.WebApp?.initDataUnsafe?.start_param ?? "";
  if (!param) return;

  if (param.startsWith("p-")) {
    const id = param.slice(2);
    if (id) window.history.replaceState(null, "", `/product/${id}`);
  } else if (param.startsWith("c-")) {
    const id = param.slice(2);
    if (id) {
      useFiltersStore.setState({ category: id });
      window.history.replaceState(null, "", "/");
    }
  }
  // promo / promo-<id> → остаёмся на главной (там видны баннеры/акции).
}

resolveDeeplink();
